var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKok(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 170,
    height: 120,
    viewBox: "0 0 170 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5640",
    "data-name": "Rectangle 5640",
    width: 170,
    height: 120,
    transform: "translate(570 999)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5619",
    "data-name": "Rectangle 5619",
    width: 179.898,
    height: 143.548,
    transform: "translate(21.16 0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47707",
    "data-name": "Path 47707",
    d: "M144.245,37.771c-2.315.066-5.257,2.943-7.621,5.8a60.832,60.832,0,0,0-4.149,5.7,6.506,6.506,0,0,0-.4,1.371,5.886,5.886,0,0,0,.005,2.083,7.659,7.659,0,0,0,.232.876c.084.259.167.473.23.629.109.005.22.006.332.008h.133c.191,0,.389,0,.594-.009.349-.012.68-.036.991-.066a4.4,4.4,0,0,1,1.19-3.438,4.174,4.174,0,0,1,3.9-1.125,4.456,4.456,0,0,1,2.513,1.852,5.916,5.916,0,0,1,1.058,3.968l21.093.066a7.923,7.923,0,0,1,1.11-4.206,4.792,4.792,0,0,1,2.792-2.209,4.364,4.364,0,0,1,1.7-.085,4.3,4.3,0,0,1,1.781.674,4.448,4.448,0,0,1,1.8,2.586,5.67,5.67,0,0,1,.209,1.653l.562-.034c.189-.01.375-.022.562-.033.033-.129.062-.259.093-.389.024-.1.049-.2.073-.305,0-.017.008-.034.011-.052.053-.214.1-.428.154-.642V47.16c-.993-1.851-3.836-2.81-6.43-3.305a32.111,32.111,0,0,0-4.943-.53c-.329-.437-.807-1.044-1.422-1.735a19.144,19.144,0,0,0-3.273-3.091c-1.2-.78-2.381-.963-5.769-1.025-.62-.012-1.2-.017-1.747-.017-4.042,0-6.15.279-7.362.314",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5621",
    "data-name": "Rectangle 5621",
    width: 43.256,
    height: 18.036,
    transform: "translate(131.935 37.457)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47716",
    "data-name": "Path 47716",
    d: "M174.728,46.433v3.835h.925V46.433Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5626",
    "data-name": "Rectangle 5626",
    width: 0.925,
    height: 3.835,
    transform: "translate(174.728 46.433)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47734",
    "data-name": "Path 47734",
    d: "M28.245,56.249a4.525,4.525,0,0,0,4.526,4.526h.1l.084,0a4.526,4.526,0,1,0-4.713-4.523",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5631",
    "data-name": "Rectangle 5631",
    width: 9.053,
    height: 9.052,
    transform: "translate(28.245 51.723)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47748",
    "data-name": "Path 47748",
    d: "M98.719,64.42c-4.141.146-7.061,3.347-8.9,5.321-3.525,3.782-7.6,7.9-12.624,12.91l-.052.057-.641-.723q-7.082-8.01-14.165-16.017a24.543,24.543,0,0,0-9.87,19.45c7.306,11.523,17.652,18.3,25.912,17.2l.244-.035a12.572,12.572,0,0,0,1.52-.33C86.052,100.571,90.53,94.4,93.4,90.45a46.526,46.526,0,0,0,6.58-12.967q.435-6.435.871-12.87a8.637,8.637,0,0,0-1.828-.2c-.1,0-.2,0-.3.006",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5634",
    "data-name": "Rectangle 5634",
    width: 48.384,
    height: 39.307,
    transform: "translate(52.464 64.414)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47752",
    "data-name": "Path 47752",
    d: "M96.784,64.709,93.01,71.58s-.775,1.935-2.517,6.581.582,13.258.1,15.87S86.913,113,86.913,113s.581,1.452,12.677,3.1c.929.125,1.9.221,2.9.29l.311.021c11.953.75,27.877-2.234,27.949-2.248h0l-.056-.416-4.783-35.58-3.067-5.125-3.25-10.29-14.28-2.416Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5637",
    "data-name": "Rectangle 5637",
    width: 43.837,
    height: 56.826,
    transform: "translate(86.913 60.33)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5639",
    "data-name": "Rectangle 5639",
    width: 201.058,
    height: 242.571,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_60",
    "data-name": "Mask Group 60",
    transform: "translate(-570 -999)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16215",
    "data-name": "Group 16215",
    transform: "translate(551 974)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16177",
    "data-name": "Group 16177"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16176",
    "data-name": "Group 16176",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47704",
    "data-name": "Path 47704",
    d: "M142.6,68.487a7,7,0,0,1,5.055-2.194l29.874-.011a3.786,3.786,0,0,0,3.695-3.87V32.423a3.785,3.785,0,0,0-3.695-3.87H130.692A3.785,3.785,0,0,0,127,32.423v43.06a3.676,3.676,0,0,0,6.307,2.736Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47705",
    "data-name": "Path 47705",
    d: "M130.714,79.864a4.111,4.111,0,0,1-1.526-.3,4.345,4.345,0,0,1-2.693-4.082V32.422a4.293,4.293,0,0,1,4.2-4.372h46.834a4.293,4.293,0,0,1,4.2,4.372v29.99a4.292,4.292,0,0,1-4.2,4.372l-29.874.011a6.452,6.452,0,0,0-4.692,2.039l-9.292,9.732a4.066,4.066,0,0,1-2.954,1.3m-.022-50.809a3.287,3.287,0,0,0-3.192,3.367V75.483a3.3,3.3,0,0,0,2.062,3.149,3,3,0,0,0,3.38-.759l9.292-9.733a7.443,7.443,0,0,1,5.418-2.349l29.874-.011a3.287,3.287,0,0,0,3.192-3.368V32.422a3.287,3.287,0,0,0-3.192-3.367Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47706",
    "data-name": "Path 47706",
    d: "M175.191,47.161v5.29c-.052.214-.1.428-.153.643l-.012.051c-.024.1-.049.2-.073.306-.03.129-.061.259-.093.389l-.562.033-.562.033a5.7,5.7,0,0,0-.209-1.652,4.447,4.447,0,0,0-1.8-2.587,4.406,4.406,0,0,0-3.482-.588,4.786,4.786,0,0,0-2.792,2.208,7.916,7.916,0,0,0-1.109,4.206l-21.094-.066a5.922,5.922,0,0,0-1.058-3.968,4.451,4.451,0,0,0-2.513-1.851,4.172,4.172,0,0,0-3.9,1.124,4.4,4.4,0,0,0-1.191,3.438c-.311.031-.642.055-.992.066-.2.007-.4.011-.593.01-.045,0-.089,0-.133,0-.112,0-.223,0-.332-.008-.063-.156-.146-.37-.23-.629a7.389,7.389,0,0,1-.232-.876,5.86,5.86,0,0,1,0-2.083,6.463,6.463,0,0,1,.4-1.371,61.325,61.325,0,0,1,4.15-5.7c2.364-2.86,5.306-5.737,7.621-5.8,1.376-.039,3.906-.394,9.109-.3,3.388.062,4.574.246,5.769,1.025a19.146,19.146,0,0,1,3.273,3.092c.615.69,1.092,1.3,1.422,1.735a32.032,32.032,0,0,1,4.943.529c2.6.5,5.438,1.455,6.43,3.306",
    fill: "#95b8d1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16182",
    "data-name": "Group 16182"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16181",
    "data-name": "Group 16181",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16180",
    "data-name": "Group 16180"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16179",
    "data-name": "Group 16179"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16178",
    "data-name": "Group 16178",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_5620",
    "data-name": "Rectangle 5620",
    width: 43.68,
    height: 18.72,
    transform: "translate(131.52 37.131)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFsAAAAnCAIAAADvtKN0AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACQSURBVGhD7dOxDYNADEBR301CKmaAGWGYhB7SRKwATZRNLhIyzZ/hv8Z2+yWXz/Hdz1/oVqbnOi/vvBRRc+pmEbIIWYQsQhYhi5BFyCJkEbIIWYQsQhYhi5BFyCJkEbIIWYQsQhYhi5BFyCJkEbIIWYQsQhahOvRdrrrUsX/kqotfQxYhi5BFqLTW5teWlyL+YSMPP7sFxZIAAAAASUVORK5CYII="
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16184",
    "data-name": "Group 16184"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16183",
    "data-name": "Group 16183",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47708",
    "data-name": "Path 47708",
    d: "M140.013,43.1a.544.544,0,0,1,.108-.325c.452-.6,2.273-2.8,4.785-3.025,2.91-.264,2.645,0,2.645,0v3.56a.54.54,0,0,1-.54.54h-6.458a.54.54,0,0,1-.54-.54Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47709",
    "data-name": "Path 47709",
    d: "M149.685,39.682l8.854-.123a.478.478,0,0,1,.326.121,21.405,21.405,0,0,1,2.506,2.654q.277.35.528.694a.481.481,0,0,1-.385.765l-11.769.059a.481.481,0,0,1-.483-.473l-.051-3.209a.481.481,0,0,1,.474-.488",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5622",
    "data-name": "Rectangle 5622",
    width: 2.777,
    height: 0.661,
    transform: "translate(149.469 45.243)",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47710",
    "data-name": "Path 47710",
    d: "M142.151,53.542a3.637,3.637,0,1,1-3.637-3.637,3.637,3.637,0,0,1,3.637,3.637",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47711",
    "data-name": "Path 47711",
    d: "M140.861,53.542a2.347,2.347,0,1,1-2.347-2.347,2.347,2.347,0,0,1,2.347,2.347",
    fill: "#fdf0d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47712",
    "data-name": "Path 47712",
    d: "M139.9,53.542a1.388,1.388,0,1,1-1.389-1.389,1.389,1.389,0,0,1,1.389,1.389",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47713",
    "data-name": "Path 47713",
    d: "M172.965,53.542a3.637,3.637,0,1,1-3.637-3.637,3.637,3.637,0,0,1,3.637,3.637",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47714",
    "data-name": "Path 47714",
    d: "M171.676,53.542a2.348,2.348,0,1,1-2.347-2.347,2.348,2.348,0,0,1,2.347,2.347",
    fill: "#fdf0d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47715",
    "data-name": "Path 47715",
    d: "M170.717,53.542a1.388,1.388,0,1,1-1.389-1.389,1.389,1.389,0,0,1,1.389,1.389",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5623",
    "data-name": "Rectangle 5623",
    width: 0.926,
    height: 3.835,
    transform: "translate(174.728 46.434)",
    fill: "#d1e2dc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16189",
    "data-name": "Group 16189"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16188",
    "data-name": "Group 16188",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16187",
    "data-name": "Group 16187"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16186",
    "data-name": "Group 16186"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16185",
    "data-name": "Group 16185",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_5625",
    "data-name": "Rectangle 5625",
    width: 0.96,
    height: 4.32,
    transform: "translate(174.72 46.251)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAAJCAIAAACXE2qwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAbSURBVBhXY7z46A4DAwMTEJNEMb748JaBgQEArEsFZQHMeGgAAAAASUVORK5CYII="
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16191",
    "data-name": "Group 16191"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16190",
    "data-name": "Group 16190",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47717",
    "data-name": "Path 47717",
    d: "M138.756,47.822a6.1,6.1,0,0,0-5.885,6.282c0,.048,0,.094,0,.14H133c0-.047,0-.093,0-.141a5.766,5.766,0,1,1,11.506,0,6.611,6.611,0,0,1-.148,1.389h.135a6.678,6.678,0,0,0,.145-1.389,6.1,6.1,0,0,0-5.885-6.282",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47718",
    "data-name": "Path 47718",
    d: "M169.24,47.888a6.1,6.1,0,0,0-5.885,6.282,6.6,6.6,0,0,0,.132,1.322h.135a6.459,6.459,0,0,1-.135-1.322,5.744,5.744,0,1,1,11.466-.72c.024-.1.049-.2.073-.305l.012-.052a6.019,6.019,0,0,0-5.8-5.2",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47719",
    "data-name": "Path 47719",
    d: "M162.349,55.344H148.758v-.049l-.266-16.714,9.19,0c.028.008,2.824.85,5.187,5.182l.006.022.265,6.092,0,.008a19.056,19.056,0,0,0-.792,5.4Zm-13.493-.1h13.388a19.278,19.278,0,0,1,.8-5.379l-.263-6.064c-2.288-4.187-4.968-5.075-5.116-5.121h-9.068Z",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5627",
    "data-name": "Rectangle 5627",
    width: 22.35,
    height: 1.058,
    transform: "translate(142.526 54.831)",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47720",
    "data-name": "Path 47720",
    d: "M175.257,54.236H174.2a.926.926,0,1,1,0-1.851h1.058a.926.926,0,1,1,0,1.851",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47721",
    "data-name": "Path 47721",
    d: "M133.995,55.03h-1.058a.925.925,0,1,1,0-1.851h1.058a.925.925,0,1,1,0,1.851",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47722",
    "data-name": "Path 47722",
    d: "M96.582,45.2a7.918,7.918,0,0,1-.858-2.909A8.327,8.327,0,0,1,96,39.377a8.235,8.235,0,0,1,1.638-3.548,8.319,8.319,0,0,1,1.589-1.416c2.215-1.465,7.113-1.87,10.875.826a10.614,10.614,0,0,1,4.268,10.325c-.683,3.493-3.53,6.545-4.818,6.195a2.312,2.312,0,0,1-1.421-1.583,2.276,2.276,0,0,1-.031-.427c-.061-3.313.981-4.314.546-5.186-.545-1.093-3.214-1.59-12.061.635",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47723",
    "data-name": "Path 47723",
    d: "M64.3,73.286l-7.7,9.56a35.57,35.57,0,0,1-5.344-1.966c-.308-.137-.624-.282-.951-.437q-.294-.14-.624-.322c-.065-.036-.132-.074-.2-.113-.433-.246-.9-.541-1.4-.873-.515-.342-1.057-.721-1.612-1.124l-.007-.005c-.429-.312-.866-.638-1.3-.97-.33-.248-.66-.5-.987-.758-.283-.219-.563-.44-.84-.66-.459-.363-.908-.724-1.339-1.074C39.742,72.712,38,71.192,38,71.192c-.17-2.218,2.211-2.838,2.211-2.838-.907-3.333,3.054-4.214,3.054-4.214s.151-.207.1-1.849c-.032-1.114,1.551-2.2,2.572-2.78.485-.276.843-.439.843-.439-7.411-4.911-7.438-7.118-7.438-7.118a1.476,1.476,0,0,1,.253-1.1c1.816-1.908,12.225,5.76,13.826,6.941,6.171,4.547,7.747,7.085,8.337,8.115A21.294,21.294,0,0,1,64.3,73.286",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47724",
    "data-name": "Path 47724",
    d: "M56.6,83.213a.327.327,0,0,1-.088-.011,35.58,35.58,0,0,1-5.4-1.987c-.31-.137-.629-.285-.959-.44q-.3-.144-.647-.334l-.2-.114c-.424-.242-.9-.54-1.423-.887s-1.057-.72-1.624-1.133q-.657-.477-1.317-.978c-.331-.25-.663-.505-.991-.762-.282-.218-.564-.44-.842-.66-.46-.365-.911-.728-1.342-1.077-2.233-1.817-3.986-3.347-4-3.363a.362.362,0,0,1-.125-.248,3.1,3.1,0,0,1,2.143-3.11,3.2,3.2,0,0,1,.374-2.318,5.011,5.011,0,0,1,2.812-1.952A9.77,9.77,0,0,0,43,62.3c-.035-1.253,1.481-2.382,2.758-3.109.106-.06.206-.115.3-.165C39.21,54.39,38.983,52.2,38.98,51.957a1.767,1.767,0,0,1,.355-1.353c1.684-1.776,8.712,2.77,14.311,6.9,6.438,4.745,7.942,7.367,8.437,8.229a21.566,21.566,0,0,1,2.583,7.5.375.375,0,0,1-.076.286l-7.7,9.56a.369.369,0,0,1-.287.136m-18.241-12.2c.428.371,1.973,1.7,3.865,3.243.43.348.878.708,1.337,1.072.274.217.553.438.835.655.327.256.656.509.984.757.436.331.872.654,1.3.965.565.411,1.1.786,1.606,1.121s.97.626,1.381.86l.193.11c.214.119.415.222.6.312.324.152.637.3.943.433a38.071,38.071,0,0,0,5.058,1.884l7.448-9.246A20.8,20.8,0,0,0,61.445,66.1c-.476-.828-1.921-3.349-8.237-8C44.54,51.7,40.6,50.338,39.867,51.111c-.152.159-.157.421-.152.835,0,.01.266,2.176,7.273,6.818a.366.366,0,0,1-.05.641s-.351.161-.813.425c-1.537.874-2.407,1.767-2.387,2.449.05,1.768-.119,2-.175,2.077a.368.368,0,0,1-.217.142,4.511,4.511,0,0,0-2.566,1.676,2.585,2.585,0,0,0-.213,2.083.369.369,0,0,1-.261.452c-.083.022-1.978.547-1.945,2.307"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47725",
    "data-name": "Path 47725",
    d: "M51.428,73.635a1.706,1.706,0,0,1-1.322.225,2.006,2.006,0,0,1,.1.544,2.539,2.539,0,0,1-.238,1.226,2.239,2.239,0,0,1-1.662,1.253,1.318,1.318,0,0,1-.779-.148,1.855,1.855,0,0,1-.307.838,1.342,1.342,0,0,1-1.12.6,1.357,1.357,0,0,1-.191,0,1.229,1.229,0,0,1-.672-.228c-.34-.285-.989-.82-1.779-1.471l-.006,0-1.73-1.422c-2.412-2.064-4.622-4.243-4.622-4.243a3.4,3.4,0,0,1,2.059-2.89c-.456-3.071,2.869-4.269,2.869-4.269a4.236,4.236,0,0,1,1.136-3.016,4.28,4.28,0,0,1,3.24-1.267c4.99,4.141,7.582,9.055,6.225,12.481a5.2,5.2,0,0,1-1.2,1.791",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47726",
    "data-name": "Path 47726",
    d: "M46,78.544c-.039,0-.077,0-.113,0A1.587,1.587,0,0,1,45,78.227c-.338-.283-.986-.818-1.776-1.469l-1.735-1.427c-2.4-2.053-4.625-4.242-4.647-4.264a.367.367,0,0,1-.109-.271,3.645,3.645,0,0,1,2.031-3.1c-.226-2.632,2.121-3.938,2.9-4.295a4.485,4.485,0,0,1,4.765-4.408.37.37,0,0,1,.214.085c5.231,4.341,7.717,9.4,6.333,12.9A5.661,5.661,0,0,1,51.688,73.9a.416.416,0,0,1-.061.05,2.055,2.055,0,0,1-1.059.327c0,.037.007.074.008.111a2.869,2.869,0,0,1-.274,1.4,2.608,2.608,0,0,1-1.952,1.459,1.741,1.741,0,0,1-.55-.027,2.157,2.157,0,0,1-.273.56,1.906,1.906,0,0,1-.18.225,1.8,1.8,0,0,1-1.219.534c-.043,0-.085,0-.126,0m-8.523-7.886c.488.476,2.424,2.346,4.485,4.11l1.725,1.418c.8.657,1.447,1.193,1.787,1.478a.9.9,0,0,0,.458.142,1.17,1.17,0,0,0,.145,0,1.061,1.061,0,0,0,.733-.3,1.3,1.3,0,0,0,.109-.138,1.5,1.5,0,0,0,.244-.671.366.366,0,0,1,.539-.282.954.954,0,0,0,.565.106,1.878,1.878,0,0,0,1.372-1.048,2.149,2.149,0,0,0,.2-1.046,1.68,1.68,0,0,0-.084-.444.367.367,0,0,1,.428-.478,1.327,1.327,0,0,0,1.011-.155,4.891,4.891,0,0,0,1.094-1.638c1.256-3.173-1.106-7.867-6.022-11.982A3.749,3.749,0,0,0,42.4,63.632a.367.367,0,0,1-.242.359c-.124.046-3.035,1.139-2.63,3.87a.369.369,0,0,1-.226.4,3.028,3.028,0,0,0-1.821,2.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47727",
    "data-name": "Path 47727",
    d: "M50.106,74.227a.366.366,0,0,1-.287-.138L41.608,63.827a.368.368,0,1,1,.574-.46L50.393,73.63a.367.367,0,0,1-.287.6",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47728",
    "data-name": "Path 47728",
    d: "M47.53,77.1a.371.371,0,0,1-.268-.115l-8.391-8.9a.368.368,0,0,1,.536-.5l8.391,8.9a.368.368,0,0,1-.268.62",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47729",
    "data-name": "Path 47729",
    d: "M26.113,67.389V53.4a3.082,3.082,0,0,1,3.073-3.073h25.37A3.082,3.082,0,0,1,57.629,53.4V67.389a3.082,3.082,0,0,1-3.073,3.073H29.186a3.082,3.082,0,0,1-3.073-3.073",
    fill: "#95b8d1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5628",
    "data-name": "Rectangle 5628",
    width: 15.121,
    height: 0.397,
    transform: "translate(42.382 55.177)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47730",
    "data-name": "Path 47730",
    d: "M53.322,52.525a.745.745,0,1,0,.745-.745.745.745,0,0,0-.745.745",
    fill: "#cc745f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47731",
    "data-name": "Path 47731",
    d: "M50.371,52.525a.745.745,0,1,0,.745-.745.745.745,0,0,0-.745.745",
    fill: "#cc745f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47732",
    "data-name": "Path 47732",
    d: "M47.42,52.525a.745.745,0,1,0,.745-.745.745.745,0,0,0-.745.745",
    fill: "#cc745f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47733",
    "data-name": "Path 47733",
    d: "M37.3,56.249a4.526,4.526,0,1,1-4.526-4.526A4.526,4.526,0,0,1,37.3,56.249",
    fill: "#cc745f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16196",
    "data-name": "Group 16196"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16195",
    "data-name": "Group 16195",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16194",
    "data-name": "Group 16194"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16193",
    "data-name": "Group 16193"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16192",
    "data-name": "Group 16192",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_5630",
    "data-name": "Rectangle 5630",
    width: 9.6,
    height: 9.6,
    transform: "translate(27.84 51.531)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAIAAAAC64paAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAA/SURBVDhPY/z+/eHPn48ZkMCPn4/QRHABxg8fjnz8dBTKIxEwQWmywKhmEsGoZhLBqGYSAUWasRRDRAJ+fmsA2t8Wu6walCYAAAAASUVORK5CYII="
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16198",
    "data-name": "Group 16198"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16197",
    "data-name": "Group 16197",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47735",
    "data-name": "Path 47735",
    d: "M28.245,56.443a.194.194,0,0,1-.194-.194,4.721,4.721,0,0,1,8.058-3.337.194.194,0,0,1-.274.274,4.332,4.332,0,0,0-7.4,3.063.194.194,0,0,1-.194.194",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47736",
    "data-name": "Path 47736",
    d: "M32.771,60.969a4.711,4.711,0,0,1-2.355-.629.193.193,0,1,1,.193-.335,4.334,4.334,0,0,0,6.5-3.756.194.194,0,1,1,.387,0,4.725,4.725,0,0,1-4.72,4.72",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47737",
    "data-name": "Path 47737",
    d: "M33.851,54.378v-.625a2.59,2.59,0,0,0-2.418,1.673H30.65v.624h.63a2.377,2.377,0,0,0,0,.584h-.63v.625h.783a2.589,2.589,0,0,0,2.418,1.672v-.625a1.959,1.959,0,0,1-1.727-1.047h1.5v-.625h-1.7a1.485,1.485,0,0,1,0-.584h1.7v-.624h-1.5a1.96,1.96,0,0,1,1.727-1.048",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47738",
    "data-name": "Path 47738",
    d: "M54.353,64.011H30.43a.823.823,0,1,1,0-1.646H54.353a.823.823,0,0,1,0,1.646",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47739",
    "data-name": "Path 47739",
    d: "M45.386,68.183H39.4a.568.568,0,1,1,0-1.135h5.988a.568.568,0,1,1,0,1.135",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47740",
    "data-name": "Path 47740",
    d: "M54.609,68.183H48.621a.568.568,0,0,1,0-1.135h5.988a.568.568,0,1,1,0,1.135",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47741",
    "data-name": "Path 47741",
    d: "M54.557,70.656h-23.8a.194.194,0,1,1,0-.387h23.8a2.882,2.882,0,0,0,2.879-2.88V53.4a2.882,2.882,0,0,0-2.879-2.879H29.187a2.882,2.882,0,0,0-2.88,2.879v8.636a.194.194,0,0,1-.387,0V53.4a3.27,3.27,0,0,1,3.267-3.266h25.37A3.27,3.27,0,0,1,57.823,53.4V67.389a3.27,3.27,0,0,1-3.266,3.267",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47742",
    "data-name": "Path 47742",
    d: "M54.353,64.2H30.43a1.018,1.018,0,0,1-1.017-1.016.194.194,0,1,1,.387,0,.63.63,0,0,0,.63.629H54.353a.63.63,0,0,0,0-1.259H51.116a.193.193,0,1,1,0-.387h3.237a1.017,1.017,0,0,1,0,2.033",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47743",
    "data-name": "Path 47743",
    d: "M61.465,66.069a19.077,19.077,0,0,0-6.8-2.614c-3.676-.551-8.2-4.613-7.831-1.537s5.278,6.3,6.093,8.339,6.243,4.448,7.647,2.762,3.667-2.257.887-6.95",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47744",
    "data-name": "Path 47744",
    d: "M59.023,73.955a5.325,5.325,0,0,1-.832-.07c-2.121-.337-4.967-1.9-5.6-3.491a11.753,11.753,0,0,0-2.32-2.82c-1.668-1.709-3.56-3.646-3.8-5.612-.03-.248-.122-1,.39-1.371.689-.492,1.9.091,3.581.9a16.289,16.289,0,0,0,4.28,1.6,19.282,19.282,0,0,1,6.944,2.671.373.373,0,0,1,.114.12c2.434,4.109,1.12,5.365-.151,6.579a9.959,9.959,0,0,0-.77.793,2.28,2.28,0,0,1-1.838.7M47.5,61.139a.362.362,0,0,0-.207.05c-.1.071-.131.327-.088.685.208,1.719,2.007,3.561,3.594,5.186a11.748,11.748,0,0,1,2.476,3.061c.481,1.206,2.974,2.711,5.034,3.038a2.154,2.154,0,0,0,1.989-.376,10.683,10.683,0,0,1,.827-.854c1.2-1.146,2.149-2.053.07-5.6a18.836,18.836,0,0,0-6.578-2.512,16.847,16.847,0,0,1-4.49-1.666A9.514,9.514,0,0,0,47.5,61.139"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47745",
    "data-name": "Path 47745",
    d: "M87.025,112.426c-.643,6.034-1.513,15.361-2.047,26.795-.917,19.623-.255,32.812.194,51.578.284,11.874.56,29.208.387,50.61l19.741.775q2.1-104.516,3.483-104.511t2.033,104.9l20.611-1.162c-.956-55.21-.615-78.094-.024-88.156a155.562,155.562,0,0,0-.653-31.353l-.968-7.742Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47746",
    "data-name": "Path 47746",
    d: "M100.848,64.613q-.435,6.435-.871,12.87A46.526,46.526,0,0,1,93.4,90.45c-2.867,3.95-7.345,10.121-13.258,11.806C71.633,104.68,60.3,97.779,52.464,85.418a24.546,24.546,0,0,1,9.87-19.45Q69.416,73.976,76.5,81.985l.641.724.052-.058c5.029-5.008,9.1-9.128,12.624-12.909,1.841-1.975,4.762-5.176,8.9-5.322a8.575,8.575,0,0,1,2.129.193",
    fill: "#0d3b66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47747",
    "data-name": "Path 47747",
    d: "M100.848,64.613q-.435,6.435-.871,12.87A46.526,46.526,0,0,1,93.4,90.45c-2.867,3.95-7.345,10.121-13.258,11.806C71.633,104.68,60.3,97.779,52.464,85.418a24.546,24.546,0,0,1,9.87-19.45Q69.416,73.976,76.5,81.985l.641.724.052-.058c5.029-5.008,9.1-9.128,12.624-12.909,1.841-1.975,4.762-5.176,8.9-5.322a8.575,8.575,0,0,1,2.129.193",
    fill: "#0d3b66"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16203",
    "data-name": "Group 16203"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16202",
    "data-name": "Group 16202",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16201",
    "data-name": "Group 16201"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16200",
    "data-name": "Group 16200"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16199",
    "data-name": "Group 16199",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_5633",
    "data-name": "Rectangle 5633",
    width: 48.96,
    height: 39.84,
    transform: "translate(52.32 64.011)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGYAAABTCAIAAADiCuUrAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAFZSURBVHhe7dC9TcNQGEZhByoGYANLSekNUqbMCmEDNiIjQEXGSEmk0NOgZANjZCsUfJZ8lB/nOufoFu93y2dUlmXWX2+rZbMSaZwXlyM76Hxs15vPdb2Taz5bnIVsGDphJyAbsE4YI7s1nbBWMnXa+iV7fX+pD3W6VJHdPzzuK6nqfe++mm9rb5IXd820zkmGkwwnGU4ynGQ4yXCS4STDSYaTDCcZTjKcZDjJcJLhJMNJhpMMJxlOMpxkOMlwkuEkw0mGkwwnGU4ynGQ4yXCS4STDSYaTDCcZTjKcZDjJcJLhJMNJhpMMJxlOMpxkOMlwkuEkw0mGkwwnGU4ynGQ4yXCS4STDSYaTDCcZTjKcZDjJcJLhJMNJhhs9PU+baVHz2aIe47yY5EU1JPvrv07YjZJ11AkbPtkxOmGDIju5TliqZJfRCUuArEedsOsiuzadsN7IktAJyrIfTz1pfBEYLgIAAAAASUVORK5CYII="
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16205",
    "data-name": "Group 16205"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16204",
    "data-name": "Group 16204",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47749",
    "data-name": "Path 47749",
    d: "M100.848,64.613q-.435,6.435-.871,12.87A46.526,46.526,0,0,1,93.4,90.45c-2.867,3.95-7.345,10.121-13.258,11.806C71.633,104.68,60.3,97.779,52.464,85.418a24.546,24.546,0,0,1,9.87-19.45Q69.416,73.976,76.5,81.985l.641.724.052-.058c5.029-5.008,9.1-9.128,12.624-12.909,1.841-1.975,4.762-5.176,8.9-5.322a8.575,8.575,0,0,1,2.129.193",
    fill: "#0d3b66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47750",
    "data-name": "Path 47750",
    d: "M130.75,114.158s-15.97,3-27.949,2.248l-.311-.021c-1-.069-1.97-.165-2.9-.29C87.5,114.45,86.913,113,86.913,113s3.194-16.354,3.678-18.967-1.839-11.226-.1-15.87S93.01,71.58,93.01,71.58l3.774-6.87,8.53-4.379,14.28,2.415,3.25,10.29,3.067,5.125,4.783,35.58Z",
    fill: "#0d3b66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47751",
    "data-name": "Path 47751",
    d: "M130.75,114.158s-15.97,3-27.949,2.248l-.311-.021c-1-.069-1.97-.165-2.9-.29C87.5,114.45,86.913,113,86.913,113s3.194-16.354,3.678-18.967-1.839-11.226-.1-15.87S93.01,71.58,93.01,71.58l3.774-6.87,8.53-4.379,14.28,2.415,3.25,10.29,3.067,5.125,4.783,35.58Z",
    fill: "#0d3b66"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16210",
    "data-name": "Group 16210"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16209",
    "data-name": "Group 16209",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16208",
    "data-name": "Group 16208"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16207",
    "data-name": "Group 16207"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16206",
    "data-name": "Group 16206",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_5636",
    "data-name": "Rectangle 5636",
    width: 44.16,
    height: 57.12,
    transform: "translate(86.88 60.171)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFwAAAB3CAIAAAAB5rD6AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAGCSURBVHhe7dq7TQNBFEBRPhEF0AEBISWQQUYLiA7oiBacQReEIEEPdGBkdmSvl9vBnpN44qs3GtnPp9vt9qQ8Pd+O08o83D2ejSMzHWXz+jJOq2RSgihBlCBKECWIEjrK5s2TzDFRgihBlCBKiCgfX+/jtFYR5VOU8cmMKEGUIEoQJUQUT3JE+fwWhX9ECaIEUYIoYRll5QvTiUkJogRRgihBlCBKWEZZ+cJ0YlKCKEGUIEoQJYgSjqL4ijwxKUGUIEoQJYgSjqJYmE6OoliYTlyfIEoQJYgSRAmHKN7jvUMU/ynec32CKEGUIEoQJRyiWJjumZQgShAliBJECaKEEcXCdM6kBFGCKEGUIEoYUfxAOzeiWJjOuT5BlCBKECWIEnZRvMcLuygWpguuTxAliBJECaKEXRRP8sIuiq/IC65PECWIEkQJooQzC9P/TEoQJYgSRAmiBFHC+cXlzzjy5/rqxqQEUYIoQZQgShAliBJECaIEUYIoQZQgShBl6eH+8RfxljwEvxJzFwAAAABJRU5ErkJggg=="
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16212",
    "data-name": "Group 16212"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16211",
    "data-name": "Group 16211",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47753",
    "data-name": "Path 47753",
    d: "M130.75,114.158s-15.97,3-27.949,2.248l-.311-.021c-1-.069-1.97-.165-2.9-.29C87.5,114.45,86.913,113,86.913,113s3.194-16.354,3.678-18.967-1.839-11.226-.1-15.87S93.01,71.58,93.01,71.58l3.774-6.87,8.53-4.379,14.28,2.415,3.25,10.29,3.067,5.125,4.783,35.58Z",
    fill: "#0d3b66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47754",
    "data-name": "Path 47754",
    d: "M111.493,47.969V67.9a6.3,6.3,0,0,1-7.017,0V47.969Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47755",
    "data-name": "Path 47755",
    d: "M107.952,69.335a6.464,6.464,0,0,1-.8-.05,6.812,6.812,0,0,1-2.877-1.076.363.363,0,0,1-.167-.307V47.969a.367.367,0,0,1,.367-.368h7.016a.368.368,0,0,1,.368.368V67.9a.37.37,0,0,1-.171.31,7.089,7.089,0,0,1-3.738,1.123M104.845,67.7a6.04,6.04,0,0,0,2.4.856,6.162,6.162,0,0,0,3.878-.859V48.337h-6.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47756",
    "data-name": "Path 47756",
    d: "M111.88,46.13a1.881,1.881,0,0,0-1.355-1.452,1.535,1.535,0,0,0-1.154.475,1.328,1.328,0,0,0-.576-.62,2.753,2.753,0,0,1-1.21-.788c-.325-.418-.206-.779-1.275-1.341a11.329,11.329,0,0,1-7.73-1.258.858.858,0,0,0-1.2.775c-.1.7-1.506,11.568,1.749,14.612a4.86,4.86,0,0,0,1.91,1.113c1.629.411,3.074-.4,5.129-1.549,1.675-.938,2.524-1.428,3.084-2.467a7.362,7.362,0,0,0,.5-3.145q.015-.334.029-.672a5.25,5.25,0,0,0,1.377-1.388,2.91,2.91,0,0,0,.723-2.295",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47757",
    "data-name": "Path 47757",
    d: "M101.914,58.123a3.9,3.9,0,0,1-.963-.121,5.2,5.2,0,0,1-2.071-1.2c-3.364-3.145-2.025-13.734-1.861-14.931a1.316,1.316,0,0,1,.6-1,1.352,1.352,0,0,1,1.09-.064.322.322,0,0,1,.046.021,11.075,11.075,0,0,0,7.461,1.225.363.363,0,0,1,.264.03,2.367,2.367,0,0,1,1.23,1.163,1.626,1.626,0,0,0,.164.278,1.962,1.962,0,0,0,.871.591c.079.032.15.063.211.092a1.487,1.487,0,0,1,.5.414,1.7,1.7,0,0,1,1.1-.3,2.237,2.237,0,0,1,1.671,1.73,3.223,3.223,0,0,1-.775,2.587,5.611,5.611,0,0,1-1.323,1.378l-.021.492a7.584,7.584,0,0,1-.54,3.3c-.622,1.154-1.6,1.7-3.228,2.614-1.717.961-3.045,1.705-4.436,1.705m-3.7-16.671a.449.449,0,0,0-.227.053.634.634,0,0,0-.24.473c-.534,3.907-.882,11.932,1.636,14.286a4.531,4.531,0,0,0,1.75,1.025c1.486.377,2.828-.376,4.858-1.512,1.678-.94,2.441-1.4,2.941-2.322a7.111,7.111,0,0,0,.453-2.987l.028-.671a.368.368,0,0,1,.158-.286,4.867,4.867,0,0,0,1.281-1.291,2.585,2.585,0,0,0,.672-2c-.128-.524-.575-1.12-1.039-1.172a1.194,1.194,0,0,0-.866.38.368.368,0,0,1-.575-.1.954.954,0,0,0-.41-.456c-.048-.024-.106-.048-.17-.075a2.657,2.657,0,0,1-1.17-.819,2.283,2.283,0,0,1-.239-.4,1.557,1.557,0,0,0-.8-.778,11.742,11.742,0,0,1-7.827-1.31.755.755,0,0,0-.217-.032"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47758",
    "data-name": "Path 47758",
    d: "M98.816,46.807a.581.581,0,1,1-.581-.581.581.581,0,0,1,.581.581",
    fill: "#311716"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47759",
    "data-name": "Path 47759",
    d: "M103.848,47a.581.581,0,1,1-.581-.581.581.581,0,0,1,.581.581",
    fill: "#311716"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47760",
    "data-name": "Path 47760",
    d: "M102.978,52.72a.958.958,0,0,1-.094.135c-.039.05-.077.1-.117.141a2.045,2.045,0,0,1-2.016.876c-.37,0-.712-.522-.853-.767-.042-.074-.066-.124-.066-.124l.169-.054a4.922,4.922,0,0,0,2.977-.207",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47761",
    "data-name": "Path 47761",
    d: "M111.493,59.194q-2.953,4.892-5.9,9.784c.207.331,2.168.822,3.639,1.8a5.45,5.45,0,0,1,1.876,2.252q1.839-5.905,3.677-11.811-.943-.528-1.935-1.146-.707-.441-1.354-.881",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47762",
    "data-name": "Path 47762",
    d: "M111.105,73.4a.369.369,0,0,1-.34-.227,5.128,5.128,0,0,0-1.739-2.087,13.84,13.84,0,0,0-2.451-1.2c-.791-.322-1.147-.474-1.3-.713a.364.364,0,0,1,0-.385l5.9-9.784a.367.367,0,0,1,.52-.114q.645.435,1.344.874c.629.394,1.275.776,1.92,1.137a.368.368,0,0,1,.172.43l-3.678,11.811a.367.367,0,0,1-.334.258h-.017m-5.026-4.521c.194.09.506.217.774.326a14.666,14.666,0,0,1,2.581,1.27,5.986,5.986,0,0,1,1.58,1.614L114.343,61.4c-.569-.323-1.136-.661-1.69-1.009q-.539-.336-1.045-.673Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47763",
    "data-name": "Path 47763",
    d: "M105.59,68.977q-.138-1.962-.387-4.065c-.214-1.785-.478-3.487-.774-5.1a8.715,8.715,0,0,0-1.691.858,8.084,8.084,0,0,0-1.8,1.609l-.474,10.314a6.954,6.954,0,0,1,1.415-1.811c.981-.981,3.432-1.471,3.714-1.8",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47764",
    "data-name": "Path 47764",
    d: "M100.461,72.958a.394.394,0,0,1-.1-.012.368.368,0,0,1-.271-.372l.473-10.314a.371.371,0,0,1,.084-.218,8.46,8.46,0,0,1,1.885-1.681,9.067,9.067,0,0,1,1.763-.894.363.363,0,0,1,.31.023.37.37,0,0,1,.181.254c.311,1.693.573,3.417.778,5.124.163,1.355.293,2.729.389,4.083a.372.372,0,0,1-.087.264,3.03,3.03,0,0,1-1.206.569,7.563,7.563,0,0,0-2.528,1.256,6.6,6.6,0,0,0-1.349,1.721.368.368,0,0,1-.326.2m.835-10.54-.407,8.876c.24-.287.486-.533.727-.774a8,8,0,0,1,2.8-1.428c.28-.1.611-.218.791-.3-.093-1.274-.218-2.563-.371-3.834-.185-1.543-.416-3.1-.69-4.634a8.345,8.345,0,0,0-1.207.654,7.751,7.751,0,0,0-1.644,1.442"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47765",
    "data-name": "Path 47765",
    d: "M157.285,123.889c.036.6.506,9.138-1.669,11.583a3.119,3.119,0,0,1-1.963,1.178,2.281,2.281,0,0,1-2.061-.785,6.089,6.089,0,0,1-.393-1.767,2.858,2.858,0,0,1-2.356.2,2.139,2.139,0,0,1-1.383-1.425,1.95,1.95,0,0,1,.3-1.421,2.982,2.982,0,0,1-2.552,0,2.785,2.785,0,0,1-1.178-1.767c-.462-1.555-.2-3.149.982-6.283,1.214-3.219,1.822-4.828,2.552-5.2,2.132-1.094,6.089,1.272,9.718,5.693",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47766",
    "data-name": "Path 47766",
    d: "M153.387,137.031a2.532,2.532,0,0,1-2.1-.96,3.989,3.989,0,0,1-.377-1.442,3.063,3.063,0,0,1-2.205.006,2.363,2.363,0,0,1-1.606-1.691,2.107,2.107,0,0,1,.017-.91,2.923,2.923,0,0,1-2.091-.269,3.278,3.278,0,0,1-1.345-1.98c-.485-1.628-.235-3.272.99-6.517,1.285-3.406,1.872-4.961,2.729-5.4,2.279-1.172,6.367,1.156,10.17,5.788a.361.361,0,0,1,.082.21c.057.946.5,9.312-1.761,11.85a3.481,3.481,0,0,1-2.2,1.3,3.006,3.006,0,0,1-.3.015m-2.188-3.3a.362.362,0,0,1,.161.037.369.369,0,0,1,.2.273,7.706,7.706,0,0,0,.334,1.618,1.931,1.931,0,0,0,1.719.626,2.778,2.778,0,0,0,1.727-1.056c1.655-1.861,1.761-8.067,1.583-11.2-3.5-4.23-7.268-6.493-9.19-5.508-.6.31-1.271,2.078-2.376,5.006-1.159,3.072-1.4,4.6-.973,6.047a2.121,2.121,0,0,0,3.231,1.535.367.367,0,0,1,.454.538,1.58,1.58,0,0,0-.251,1.146,1.686,1.686,0,0,0,1.16,1.159,2.466,2.466,0,0,0,2.041-.177.363.363,0,0,1,.178-.046"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47767",
    "data-name": "Path 47767",
    d: "M147.855,131.54a76.692,76.692,0,0,0,2.362-9.845l-.293-.028a76.378,76.378,0,0,1-2.351,9.787Z",
    fill: "#311716"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47768",
    "data-name": "Path 47768",
    d: "M150.807,105.14c1.23,1.429,2.943,3.523,4.81,6.184,3.414,4.867,5.122,7.3,5.988,10.5,1.876,6.933-.58,15.22-3.828,16a2.981,2.981,0,0,1-2.976-.89,2.894,2.894,0,0,1,.031-2.545c.387-.659,2.643-4.627.981-8.246-1.121-2.443-3.894-4.434-4.464-4.02-.118.086-.175.284-.051.879.622,3,2.191,4.3,1.963,6.282-.063.55-.123,1.073-.491,1.276-1.358.752-5.4-3.7-7.755-7.166A24.629,24.629,0,0,1,140.4,112.4a23.1,23.1,0,0,1,.589-9.129l9.816,1.865",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47769",
    "data-name": "Path 47769",
    d: "M157.047,138.275a3.035,3.035,0,0,1-2.553-1.134,3.185,3.185,0,0,1,0-2.894c.626-1.07,2.485-4.681.985-7.947-1.017-2.214-3.288-3.828-3.883-3.863a2.166,2.166,0,0,0,.061.494,13.439,13.439,0,0,0,1.143,3.16,5.791,5.791,0,0,1,.826,3.239c-.071.621-.145,1.261-.678,1.556-1.95,1.077-6.72-5.048-8.237-7.28a25.161,25.161,0,0,1-4.674-11.152,23.366,23.366,0,0,1,.6-9.274.37.37,0,0,1,.424-.266l9.816,1.865a.364.364,0,0,1,.21.122c1.7,1.975,3.327,4.066,4.833,6.212,3.435,4.9,5.158,7.354,6.041,10.619,1.427,5.272.368,11.075-1.416,14.081a4.664,4.664,0,0,1-2.681,2.373,3.538,3.538,0,0,1-.815.089m-5.5-16.57a1.242,1.242,0,0,1,.321.046,8.711,8.711,0,0,1,4.275,4.243c1.648,3.59-.348,7.479-1,8.585a2.529,2.529,0,0,0-.04,2.157,2.636,2.636,0,0,0,2.582.735,3.986,3.986,0,0,0,2.22-2.033c1.705-2.874,2.713-8.439,1.34-13.514-.85-3.14-2.549-5.562-5.933-10.387-1.469-2.093-3.051-4.13-4.705-6.06l-9.353-1.776a22.574,22.574,0,0,0-.493,8.653,24.167,24.167,0,0,0,4.553,10.838c2.762,4.063,6.365,7.549,7.273,7.051.2-.112.253-.561.3-.995a5.187,5.187,0,0,0-.761-2.844,14.094,14.094,0,0,1-1.2-3.324c-.119-.578-.132-1.012.2-1.25a.7.7,0,0,1,.419-.125"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47770",
    "data-name": "Path 47770",
    d: "M116,65.77c0,3.767,6.664,23.18,6.664,23.18l11.081,25.07a1.967,1.967,0,0,0,1.805,1.169c10.8-.019,17.371-4.059,20.165-6.277a1.962,1.962,0,0,0,.22-2.874l-17.577-18.9-.337-.363s-.013-.026-.041-.078c-.689-1.341-10.174-19.608-15.895-22.957C116.141,60.265,116,65.77,116,65.77",
    fill: "#0d3b66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47771",
    "data-name": "Path 47771",
    d: "M108.218,35.4c0-.275,2.983-5.94,7.388-3.875,2.46,1.154,9.974,30.25-1.606,24.8-4.681-2.2,1.511-16.661-1.285-16.54-6.333.276-4.5-4.385-4.5-4.385",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47772",
    "data-name": "Path 47772",
    d: "M93.017,37.966a.367.367,0,0,1-.244-.093l-4.308-3.825a.367.367,0,1,1,.488-.549l4.308,3.824a.368.368,0,0,1-.244.643",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47773",
    "data-name": "Path 47773",
    d: "M92.323,41.42a.354.354,0,0,1-.079-.009l-4.725-1.04a.368.368,0,1,1,.158-.718l4.725,1.04a.368.368,0,0,1-.079.727",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47774",
    "data-name": "Path 47774",
    d: "M77.042,89.976l-.051,0a.368.368,0,0,1-.314-.415,20.048,20.048,0,0,0,.106-6.759.367.367,0,1,1,.712-.181c.024.092.571,2.321-.089,7.041a.369.369,0,0,1-.364.317",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47775",
    "data-name": "Path 47775",
    d: "M132.923,90.676a.368.368,0,0,1-.21-.67l5.094-3.531a.368.368,0,0,1,.419.605l-5.094,3.53a.362.362,0,0,1-.209.066",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47776",
    "data-name": "Path 47776",
    d: "M102.8,116.774h0a.368.368,0,0,1-.366-.37c0-.1.058-10.467.233-22.261a183.752,183.752,0,0,1,2.562-25.231.368.368,0,0,1,.724.131,182.829,182.829,0,0,0-2.551,25.11c-.174,11.791-.232,22.152-.232,22.255a.368.368,0,0,1-.368.366",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47777",
    "data-name": "Path 47777",
    d: "M90.264,114.759a.393.393,0,0,1-.1-.012c-2.872-.76-3.487-1.336-3.6-1.612a.367.367,0,0,1-.02-.207c.032-.164,3.2-16.383,3.678-18.964a21.562,21.562,0,0,0-.271-4.749c-.418-3.642-.938-8.174.19-11.184,1.723-4.6,2.512-6.568,2.52-6.588a.368.368,0,0,1,.683.274c-.008.019-.795,1.986-2.514,6.573-1.066,2.843-.557,7.278-.149,10.841a21.546,21.546,0,0,1,.264,4.967c-.451,2.435-3.289,16.972-3.643,18.786a9.413,9.413,0,0,0,3.048,1.152.368.368,0,0,1-.094.723M86.913,113h0Z",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47778",
    "data-name": "Path 47778",
    d: "M148.693,113.219a.367.367,0,0,1-.133-.71,26.7,26.7,0,0,0,6.922-3.885,1.6,1.6,0,0,0,.18-2.336.368.368,0,0,1,.538-.5,2.331,2.331,0,0,1-.261,3.413,27.456,27.456,0,0,1-7.113,3.994.361.361,0,0,1-.133.025",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47779",
    "data-name": "Path 47779",
    d: "M135.542,115.557a2.333,2.333,0,0,1-2.137-1.388L122.324,89.1c-.037-.1-2.6-7.6-4.533-14.1a.367.367,0,1,1,.7-.208c1.924,6.492,4.487,13.97,4.513,14.045l11.069,25.041a1.6,1.6,0,0,0,1.465.95h0a38.712,38.712,0,0,0,8.1-.845.368.368,0,0,1,.156.719,39.44,39.44,0,0,1-8.259.861Z",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47780",
    "data-name": "Path 47780",
    d: "M110.223,48.288a.368.368,0,0,1-.234-.652.81.81,0,0,0,.325-.988.638.638,0,0,0-.669-.39.368.368,0,1,1-.134-.723,1.367,1.367,0,0,1,1.47.8,1.526,1.526,0,0,1-.524,1.866.366.366,0,0,1-.234.084",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47781",
    "data-name": "Path 47781",
    d: "M105.183,46.43a.371.371,0,0,1-.278-.126,3.515,3.515,0,0,0-3.326-.558.368.368,0,1,1-.387-.625c1.2-.745,3.574-.1,4.269.7a.368.368,0,0,1-.278.609",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47782",
    "data-name": "Path 47782",
    d: "M96.973,46.035a.368.368,0,0,1-.309-.565,2.561,2.561,0,0,1,3.068-.564.368.368,0,0,1-.276.682,1.883,1.883,0,0,0-2.173.277.366.366,0,0,1-.31.17",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47783",
    "data-name": "Path 47783",
    d: "M100.812,51.346a.314.314,0,0,1-.061-.005c-1.962-.332-2.09-.642-2.151-.791-.112-.27.051-.542.444-1.2a7.629,7.629,0,0,0,1.173-2.735.365.365,0,0,1,.4-.331.369.369,0,0,1,.331.4,8.161,8.161,0,0,1-1.273,3.04c-.106.179-.23.387-.307.532a9.927,9.927,0,0,0,1.5.36.368.368,0,0,1-.061.73",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47784",
    "data-name": "Path 47784",
    d: "M100.6,53.474a2.165,2.165,0,0,1-1.2-.27.368.368,0,1,1,.42-.6c.448.311,2.056.051,3.055-.234a.368.368,0,0,1,.2.708,10.285,10.285,0,0,1-2.477.4",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16214",
    "data-name": "Group 16214"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16213",
    "data-name": "Group 16213",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47785",
    "data-name": "Path 47785",
    d: "M181.178,143.755H24.859a.207.207,0,0,1,0-.414H181.178a.207.207,0,1,1,0,.414",
    fill: "#060e12"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKok);
export default __webpack_public_path__ + "static/media/kok.3c04f42e1e3221f8953e31e6b53eece2.svg";
export { ForwardRef as ReactComponent };